import { get } from 'lodash';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { isProduction } from '../utils/environment';
import cookies from 'js-cookie';

export const ENDPOINT_HOST = process.env.INTERNAL_GQL_HOST || process.env.GRAPHQL_BASE_URL || '';
export const ENDPOINT_PATH = '/directory/v2/gql';
export const ENDPOINT = `${ENDPOINT_HOST}${ENDPOINT_PATH}`;

const httpLinkHeaders = {
    'X-ZData': window.btoa(
        JSON.stringify({
            host: window.location.hostname,
        })
    ),

    // TODO: figure out how to support the various incarnations of this if it matters
    // this should match the ansible-set APPLICATION_NAME param to be consistent with SSR traffic
    'X-ZD-Application': 'patient-web-app',

    // "X-ZD-Referer" is not a typo. It's mispelled in the HTTP spec but spelled correctly in the DOM.
    'X-ZD-Referer': document.referrer,

    'X-ZD-Url': window.location.href,
};

const sut = cookies.get('sut');

if (sut) {
    httpLinkHeaders['X-ZD-User-Token'] = sut;
}

const httpLink = createHttpLink({
    credentials: 'same-origin',
    fetch: fetchWithRetries,
    fetchOptions: { retries: 1 },
    headers: httpLinkHeaders,
    uri: ENDPOINT,
});

const errorLink = onError(({ networkError }) => {
    if (get(networkError, 'status') >= 400) {
        if (window && window.onerror) {
            window.onerror(`GQL Response Error ${networkError.status}: ${networkError}`, 'apolloClient.js', 16);
        }
    }
});

const link = errorLink.concat(httpLink);

const client = new ApolloClient({
    cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
    connectToDevTools: !isProduction(),
    link,
    ssrMode: typeof window === 'undefined',
});

export default client;
